<script>
import {useStore} from "vuex";
import {ref} from "vue";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";
import FreeWorld from "@/assets/js/FreeWorld";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import useClipboard from "vue-clipboard3";

export default {
  name: "RegisterPage",
  components: {LoadingPage},
  setup(){

    let store = useStore()

    let country = ref(FreeWorld.PinkMan(store.state.country , 'de'))
    let city = ref(country.value[0].city)

    let id = null

    let loading = ref(false)
    let data = ref({
      phone: useRoute().params.phone,
      name: '',
      state_id: country.value[0].id,
      city_id: city.value[0].id,
      action: 'user',
      ref_code: '',
    })


    function chang_states() {
      country.value.forEach((item)=>{
        if (item.id === data.value.state_id){
          city.value = item.city
          data.value.city_id = city.value[0].id
          return false
        }
      })
    }
    function register() {
      if (data.value.name.trim().length === 0){Swals.Warning('لطا نام و نام خانوادگی خود را وارد کنید!') ; return false}

      loading.value = true
      FreeWorld.Heisenberg(data.value , 'signup').then((res)=>{

        loading.value = false
        if (res.data.status === 'ok'){
          if (res.data.event === 'user add'){
            store.commit('set_helpers' , true)
            let uid = FreeWorld.PinkMan(res.data.user_id , 'en')
            id = res.data.user_id
            localStorage.setItem('uid' , uid)
            runApp_user()
          }else if(res.data.event === 'user exist'){
            Swals.Fault('شما قبلا با این شماره ثبت نام کرده اید!' , 'LoginPage')
          }
        }else if(res.data.event === 'ref code not exist'){
          Swals.Fault('کد معرف وارد شده اشتباه اصت!')
        }else {
          Swals.Fault('متاسفانه مشکلی پیش آمده است!')
        }

      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , register)
      })
    }

    function runApp_user() {
      loading.value = true

      FreeWorld.Heisenberg({action: 'city'}, 'public_info').then((res) => {

        store.commit('set_country', res.data)
        let country = res.data

        FreeWorld.Heisenberg({action: 'user_info' , user_id:id}, 'public_info').then((res) => {

          country.forEach((item) => {
            if (item.id === res.data.state_id) {
              res.data.state = item.name
              item.city.forEach((item_city) => {
                if (item_city.id === res.data.city_id) {
                  res.data.city = item_city.name
                  return false
                }
              })
            }
          })

          store.commit('set_profile', res.data)

          FreeWorld.Heisenberg({action: 'slider' , user_id:id}, 'public_info').then((res) => {

            store.commit('set_slider', res.data)

            FreeWorld.Heisenberg({action: 'tell'}, 'public_info').then((res) => {

              store.commit('set_info_support', res.data)

              FreeWorld.Heisenberg({action: 'adver_category'}, 'public_info').then((res) => {

                store.commit('set_category', res.data)

                loading.value = false
                window.location.href = '/HomePage'

              }).catch((res) => {
                loading.value = false
                Swals.Catch(res, runApp_user)
              })

            }).catch((res) => {
              loading.value = false
              Swals.Catch(res, runApp_user)
            })

          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, runApp_user)
          })

        }).catch((res) => {
          loading.value = false
          Swals.Catch(res, runApp_user)
        })

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, runApp_user)
      })
    }

    const {toClipboard} = useClipboard()
    async function call_support() {
      let phone_support = store.state.info.phone
      await Swals.Dialog(phone_support, null, 'کپی کردن', 'انصراف').then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(phone_support)
            Swals.Done('شماره پشتیبانی با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره پشتیبانی کپی نشد!');
          }
        }
      });
    }

    return{

      loading,
      data,
      country,
      city,
      chang_states,
      register,
      call_support,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div class="" :class="loading ? 'activeClass':''" id="main">
    <div class="holder-logo rounded-bottom-5 w-100 max_width">
      <div class="position-relative w-100 h-100 d-flex justify-content-center align-items-start">
        <img class="img_logo" src="../assets/img/logoapp.png" alt="">

        <div class="list-access bg-white rounded-4 p-2 shadow-custom">
          <div class="position-relative">
            <div class="rounded-pill text-white shadow-custom font-5 bg-color-liner p-3 mb-4">
              <p class="text-center font-bold">اطلاعات خود را وارد کنید</p>
            </div>

            <div class="mb-3">
              <p class="font-5 mb-2 me-2">نام و نام خانوادگی</p>

              <input v-model="data.name" class="w-100 p-3 text-center shadow-custom rounded-pill" type="text">
            </div>

            <div class="mb-3">
              <p class="font-5 mb-2 me-2">استان</p>

              <select v-model="data.state_id" @change="chang_states" class="w-100 bg-white p-3 text-center shadow-custom rounded-pill">
                <option v-for="item in country" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>

            <div class="mb-3">
              <p class="font-5 mb-2 me-2">شهر</p>

              <select v-model="data.city_id" class="w-100 bg-white p-3 text-center shadow-custom rounded-pill">
                <option v-for="item in city" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>

            <div class="mb-6">
              <p class="font-5 mb-2 me-2">کد معرف (اختیاری)</p>

              <input v-model="data.ref_code" onkeydown="return event.key !== ' '" class="w-100 p-3 text-center shadow-custom rounded-pill" type="tel">
            </div>


            <div class="btn-center w-100 d-flex justify-content-center position-absolute">
              <div class="p-1 bg-white w-50 shadow-custom rounded-pill">
                <p @click="register" class="bg-color-liner p-3 text-center text-white font-bold rounded-pill">ثبت</p>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="position-fixed w-100 max_width d-flex bottom-1">
        <a href="https://sangin-savaran.com/" target="_blank" class="bg-color-light p-1 d-flex text-decoration-none align-items-center rounded-pill me-2">
          <img style="width: 3rem" class="icon_shadow" src="../assets/img/icon-call-bg-white.svg" alt="">
          <p class="font-5 text-color mx-3">کمک بگیرید</p>
        </a>
      </div>
    </div>
  </div>

</template>

<style scoped>
.img_logo {
  width: 35%;
  margin-top: 55px;
}
.holder-logo {
  background-image: linear-gradient(to bottom left, #46E2FF, #268EE0, #0335BE);
  position: fixed;
  top: 0;
  height: 45%;
}
.list-access {
  position: absolute;
  bottom: -23rem;
  width: 80%;
}
.btn-center {
  bottom: -6.6rem;
}
</style>